<template>
  <div class="copy-wrap">
    <resize-container :tabShow="tabShow">
      <div class="tree-content box" v-show="tabShow" slot="left">
        <tab-tree :data="viewTreeData" :checkbox="true" @tabTreeDefault="tabTreeDefault" @change="tabTreeChange" @changeCompany="changeCompany"></tab-tree>
      </div>
      <div class="right-content">
        <div class="search-box box">
          <time-search ref="timeSearch" :control="{data:timeData}" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick" :showExportBtn="true" @exportExc="bindExportExc">
            <span class="typetext" style="padding-left:10px;">查询类型：</span>
            <el-select class="selectsize left" style="width:150px;" v-model="queryType">
              <el-option label="用量" value="1"></el-option>
              <el-option label="表码值" value="2"></el-option>
            </el-select>
          </time-search>
        </div>
        <div class="table-content box" v-loading="loading">
          <nk-table id="table" :showPage="true" :page="page" :data="tableData" :noDataTitle="'该时间段暂无数据'" :columns="columns" :border="false" :rowselect="true" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
            <el-table-column slot="total" fixed="left" :label="'合计(单位：'+unit+')'" width="160" align="center">
              <template slot-scope="scope">
                <span style="color:#0197ee">{{scope.row.total}}</span>
              </template>
            </el-table-column>
          </nk-table>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import {
  findDataByParam,
  dateToColumns,
  toPage,
  exportExcel,
} from "@/utils/index.js";
import api from "@common/api/index.js";
import TabTree from "@/components/common/TabTree.vue";
import TimeSearch from "@/components/common/TimeSearch.vue";
import NkTable from "@/components/common/NkTable";
import dateTool from "@/utils/dateTool";
import ResizeContainer from "@/components/common/resizeContainer.vue";
import { isNull } from "util";
let allTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  },
];
export default {
  components: { TabTree, TimeSearch, NkTable, ResizeContainer },
  data () {
    return {
      unit: '',
      viewTreeData: [],
      tabShow: true,
      timeData: allTimeData,
      selectedDate: {},
      tableData: [],
      page: {
        pageSizes: [10, 20, 50, 100, 500, 1000], //每页显示条目个数
        size: 10,
        total: 0,
        pageIndex: 1,
      },
      columns: [],
      checkedNodeKeys: [],
      energyType: 1,
      queryType: "1",
      loading: false,
    };
  },
  created () {
  },
  methods: {
    /* 切換公司树 */
    changeCompany (companyId) {
      let vm = this;
      api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(companyId, "/report/copy/copy6", null)
        .then((res) => {
          const viewTreeData = findDataByParam("viewTree", true, res.data);
          const energyType = findDataByParam("dataType", false, res.data);
          const unit = findDataByParam("unit", false, res.data);
          vm.unit = unit
          vm.energyType = energyType;
          vm.viewTreeData = viewTreeData;
        });
    },
    tabTreeDefault (node) {
      let vm = this;
      let dataTypeOne = vm.dataTypeOne;
      vm.checkedNodes = JSON.parse(JSON.stringify([node]));
      let measureIdS = vm.deep([node]);
      vm.checkedNodeKeys = [];
      measureIdS.forEach((item) => {
        vm.checkedNodeKeys.push(item.measureId);
      });
      let time = new Date();
      let startTime = dateTool.format(time, "yyyy-MM-dd ") + "00:00:00";
      time.setDate(time.getDate() + 1);
      let endTime = dateTool.format(time, "yyyy-MM-dd") + " 00:00:00";
      vm.selectedDate = {
        dateType: "day",
        endTime: endTime,
        startTime: startTime,
      };
      vm.TimeControlClick(vm.selectedDate);
    },
    /**
     * 树转数组扁平化结构
     * 深度优先遍历  堆栈  后进先出
     */
    deep (node) {
      let stack = node,
        data = [];
      while (stack.length != 0) {
        let pop = stack.pop();
        data.push({
          id: pop.id,
          name: pop.measureName,
          parentId: pop.parentId,
          measureId: pop.measureId,
        });
        let children = pop.children;
        if (children) {
          for (let i = children.length - 1; i >= 0; i--) {
            stack.push(children[i]);
          }
        }
      }
      return data;
    },
    tabTreeChange (nodes, ids, data) {
      let vm = this;
      vm.checkedNodes = JSON.parse(JSON.stringify(nodes));
      vm.checkedNodeKeys = [];
      data.forEach((item) => {
        vm.checkedNodeKeys.push(item.measureId);
      });
      vm.getTableData(1);
    },
    timeControlChange () { },
    //查询事件
    TimeControlClick (e) {
      let vm = this;
      vm.selectedDate = e;
      vm.selectedDate.dataTypeOne = vm.dataTypeOne;
      this.getTableData(1);
    },

    /**
     * 获取列表数据
     */
    getTableData (pageIndex) {
      let vm = this;
      vm.loading = true;
      let checkedNodeKeys = vm.checkedNodeKeys;
      if (checkedNodeKeys.length == 0) {
        vm.$message.warning("请选择查询的计量点！");
      }
      let page = toPage(checkedNodeKeys, pageIndex, vm.page.size);
      let elem = vm.selectedDate;
      let measureIds = page.arr;
      let queryType = ""; //查询类型（1用量2表码）
      let timeType = ""; //时间类型（1 日，2 月，3 年）
      if (vm.selectedDate.dateType == "day") {
        timeType = 1;
      } else if (vm.selectedDate.dateType == "month") {
        timeType = 2;
      } else {
        timeType = 3;
      }
      let columns = [
        {
          prop: "name",
          label: "计量表名称",
          fixed: "left",
          width: 230,
          show: true,
          align: "left",
        },
        {
          prop: "total",
          fixed: "left",
          label: "合计",
          width: 110,
          align: "right",
          slot: "total",
          show: vm.queryType == "2" ? false : true,
        },
      ];

      if (measureIds.length == 0) {
        vm.tableData = [];
        vm.loading = false;
      } else {
        vm.$api.tmp
          .getEnergyStatistics(
            measureIds,
            vm.selectedDate.startTime,
            vm.energyType,
            timeType,
            vm.queryType
          )
          .then((res) => {
            if (res.success) {
              vm.loading = false;
              let data = [];
              for (const i in res.data[0].other) {
                columns.push({
                  prop: i,
                  label: i,
                  align: "right",
                  show: true,
                  width: "150"
                });
              }
              for (let index = 0; index < res.data.length; index++) {
                let item = res.data[index].other;
                item.name = res.data[index].name;
                item.total = res.data[index].total;
                data.push(item);
              }
              vm.columns = columns;
              vm.page.pageIndex = pageIndex;
              vm.page.total = page.total;
              vm.tableData = data;
            } else {
              vm.$message.error(res.msg);
            }
          })
          .catch((error) => { });
      }
    },
    bindExportExc () {
      //表格导出
      let name = "抄表管理";
      exportExcel("table", name, this.selectedDate);
    },
    handleCurrentChange (val) {
      this.getTableData(val);
    },
    handleSizeChange (val) {
      this.page.size = val;
      this.getTableData(1);
    },

  },
};
</script>

<style lang="scss" scoped>
.copy-wrap {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  display: flex;
}
.tree-content {
  min-width: 200px;
  margin-right: 14px;
}
.right-content {
  display: flex;
  flex-flow: column;
  height: 100%;
}
.search-box {
  height: 36px;
}
.table-content {
  width: 100%;
  margin-top: 14px;
  padding: 10px;
  box-sizing: border-box;
}
</style>